import React from 'react';
import { RedirectionButton } from './components/Button';
import { Container } from './components/Container';
import { CommonComponent, CommonComponentContent } from './components/CommonComponent';

const classNames = require('html-classnames');

interface PageProps {
  withContrastHeadline: boolean,
  title: string,
  content: Array<CommonComponentContent>, // From markdown
}

// Watch out! This is used in /polityka-prywatnosci and any other /informacje/
export const PageContent: React.FC<PageProps> = ({ title, content, withContrastHeadline }: PageProps) => {
  const topUnitClassName = classNames('page__top_unit', {
    '--with-contrast-headline': withContrastHeadline,
  });

  const buttonColor = withContrastHeadline ? '#FAFAFA' : 'var(--color-primary)';
  const arrowColor = withContrastHeadline ? undefined : 'var(--color-background)';
  return (
    <main className="page">
      <div className={topUnitClassName}>
        <div className="page__nav_title_container">
          <div className="page__navigation">
            <RedirectionButton
              url="/filary"
              color={buttonColor}
              arrowColor={arrowColor}
              text="Filary naszej polityki"
            />
          </div>
          <h1 className="page__title">{title}</h1>
        </div>
      </div>
      <Container>
        {content?.map((c, i) => <CommonComponent key={i} {...c} />)}
      </Container>
    </main>
  );
};
